export type { AiExploreTheme, AiSpot, AiExploreRequest, AiExploreResponse } from '@ridehub/shared';

export const THEME_LABELS: Record<
  import('@ridehub/shared').AiExploreTheme,
  { label: string; icon: string; description: string }
> = {
  any: { label: 'おまかせ', icon: '✨', description: 'AIが厳選したスポット' },
  rest_toilet: { label: '休憩・トイレ', icon: '🚻', description: '公園・トイレ・ベンチ' },
  convenience_store: { label: 'コンビニ', icon: '🏪', description: '補給・休憩に便利' },
  food: { label: '食事', icon: '🍽️', description: '食事処・カフェ・グルメ' },
  emergency: { label: '緊急・トラブル', icon: '🔧', description: '修理・空気入れ・パーツ' },
  scenic: { label: 'ビュースポット', icon: '🏔️', description: '絶景・撮影スポット' },
  bath: { label: '銭湯・温泉', icon: '♨️', description: 'ライド後の入浴・温泉' },
};
